var vex = require('./vex')
vex.registerPlugin(require('vex-dialog'))
module.exports = vex



//////////////////
// WEBPACK FOOTER
// ./node_modules/vex-js/src/vex.combined.js
// module id = 717
// module chunks = 0